import RootWindowMixin from 'GroomyRoot/mixins/Window.js'

export default {
    mixins: [RootWindowMixin]
}